
import { configStore } from "@/store/store";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class CodeBoxDialog extends Vue {
  @Prop()
  open!: boolean;

  get iframeSrc() {
    return configStore.builderMode === "breakdance"
      ? "https://breakdance.com/codebox-iframe/"
      : "https://oxygenbuilder.com/codebox-iframe/";
  }
}
